import React, { Fragment, useEffect, useState } from "react";
import PlanetCard from "../PlanetCard/PlanetCard";
import { useDispatch } from "react-redux";
import {
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTranslation } from "react-i18next";
import { logout, signUpService } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import "./ExternalVerifierLogin.scss";
import { toastMessage, zeroPad } from "../../helper";
import {
  externalVerifierOtpVerify,
  requestExternalVerifierOtp,
  requestExternalVerifierResendOtp,
} from "../../services/verificationService";
import OtpInput from "react-otp-input";
import { externalVerifierLogin, setToken } from "../../actions/authActions";

export default function ExternalVerifierLogin(props: any) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [otp, setOtp] = useState("");
  const [externalVerifierMail, setExternalVerifierMail] = useState("");
  const [showOTPScreen, setShowOTPScreen] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  const [seconds, setSeconds] = useState(30);
  let [auditRequestId, setAuditRequestId] = useState("");
  let [requestCompanyName, setRequestCompanyName] = useState("");

  const onSubmit = () => {
    const requestId = {
      auditRequest: auditRequestId,
    };
    requestExternalVerifierOtp(requestId)
      .then((res: any) => {
        setExternalVerifierMail(res.data.message.split(": ")[1].trim());
        setShowOTPScreen(true);
        setSeconds(30);
        setShowTimer(true);
        //   navigate("/auth/login");
      })
      .catch((e: any) => {
        console.log(e);
        toastMessage(e.response.data.message, "error");
      });
  };
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((seconds) => seconds - 1);
      }
      if (seconds <= 0) {
        clearInterval(myInterval);
        setShowTimer(false);
        setSeconds(30);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });
  const onOTPChange = async (value: string) => {
    setOtp(value);
    if (value.length === 6) {
      externalVerifierLogin(value, auditRequestId, externalVerifierMail)
        .then((res) => {
          if (res.data.token) {
            dispatch(setToken(res.data.token));
            navigate("/log/Emissions"); // Navigation after successful login
          }
        })
        .catch((error) => {
          // Handle any errors from externalVerifierLogin
          console.error("Login failed:", error);
        });
    }
  };

  const resendOTP = () => {
    setSeconds(30);
    setShowTimer(true);
    const requestId = {
      auditRequest: auditRequestId,
      email: externalVerifierMail,
    };
    requestExternalVerifierResendOtp(requestId)
      .then(() => {
        toastMessage("OTP Resent To Mail", "info");
      })
      .catch((err: any) => {
        toastMessage(err.response.data.message, "error");
        console.log(
          "Error:",
          err.response && err.response.data && err.response.data.message
        );
      });
  };

  useEffect(() => {
    logout();
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("id") != null) {
      setAuditRequestId(searchParams.get("id") || "");
      setRequestCompanyName(searchParams.get("company") || "");
    }
  }, []);
  return (
    <Fragment>
      {!showOTPScreen ? (
        <div className="flex flex-col h-full items-center justify-center">
          <div className="flex flex-col items-center justify-center">
            <div className="m-4 font-bold text-xl">You're Invited</div>
            <div className="flex flex-col items-center justify-center">
              You've been invited by
              <span>
                <span className="font-bold">{requestCompanyName}</span> company
                to verify.
              </span>
              Get OTP to get started.
            </div>
          </div>
          <div>
            <Button
              variant="contained"
              sx={{
                padding: "10px !important",
                color: "white",
                width: "15rem",
              }}
              style={{
                marginTop: "15px",
                fontWeight: "700",
                textTransform: "none",
              }}
              className={"pw-cursor-pointer pw-primary-button"}
              onClick={onSubmit}
              // disabled={!validateForm()}
            >
              GET OTP
            </Button>
          </div>
        </div>
      ) : (
        <div className="">
          <div className="flex flex-row gap-2 font-bold text-2xl my-8">
            <div
              onClick={() => {
                setShowOTPScreen(false);
              }}
            >
              <ArrowBackIcon />
            </div>
            OTP Verification
          </div>
          <div className="font-bold">Enter OTP</div>
          <div className="flex flex-col pw-overflow-y-auto pw-verifier-otp">
            <OtpInput
              value={otp}
              onChange={onOTPChange}
              numInputs={6}
              isInputNum={true}
              className={"pw-border"}
              separator={<span>&nbsp;</span>}
            />
          </div>
          <div className="pw-verifier-otp-account flex flex-row">
            <div
              className={`pw-resend-text flex flex-row ${
                !showTimer
                  ? "pw-cursor-pointer "
                  : "cursor-not-allowed opacity-50"
              }`}
              onClick={!showTimer ? resendOTP : () => {}}
            >
              <div className={` ${showTimer ? "" : "pw-primary-color"}`}>
                <RefreshIcon sx={{ fontSize: "18px" }} />
                <span> {t("Resend OTP")}</span>
              </div>
            </div>

            <div className={` ${showTimer ? "" : "pw-display-none"}`}>
              00:
              {zeroPad(seconds, 2)}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
